import { ItemWithMetaData, Rating } from "../api/Items";
import {
  contentMediaToMediaExternalInternal,
  MediaExternalInternalURLs,
} from "../posts/PostImage";
import { formattedDate } from "../utils";

export function getDisplayDate(datePosted: string): string {
  if (datePosted) {
    return formattedDate(new Date(datePosted));
  }
  return "";
}

export function justBehaviorRatings(ratings: Rating[]) {
  return ratings
    .filter(
      (rating) => rating.name !== "SKIP" && rating.score_type === "behavior" // TODO: if this values for this kind of filters are going to be system constant handle them as so
    )
    .sort(function (a, b) {
      if (a.name < b.name) {
        return -1;
      }
      if (a.name > b.name) {
        return 1;
      }
      return 0;
    });
}

export function contentRatingsAndImagesUrlFromPost(post: ItemWithMetaData) {
  const postContent: any = post.item.content;
  const ratings = justBehaviorRatings(post.rating);
  const postImageUrls: MediaExternalInternalURLs[] =
    contentMediaToMediaExternalInternal(postContent.media);
  return { postContent, ratings, postImageUrls };
}
